import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header.js';
import Image from '../components/Image.js';
import CaveFlask from '../images/cave_controller.png'
import RoverGamePlay from '../videos/rover_gameplay.mp4';
import Footer from '../components/Footer.js';


const PostPageStyle = styled.div`
  font-size: clamp(0.5rem, 2vw + 0.5rem, 1.7rem);
  font-family: Space Mono, monospace;
  display: flex;
  flex-direction: column;
  background: #E6F5EE;
  color: #2A3230;
  min-height: 100vh;
`;

const PostPageBodyStyle = styled.div`
  font-size: clamp(0.5rem, 2vw + 0.5rem, 1.1rem);
  text-align: justify;
  margin-top: 5vh;
  margin-bottom: 5vh;
  margin-left: 10vw;
  margin-right: 10vw;  
`;

const VideoWrapper = styled.div`
  margin: 2vh 10vw;
  video {
    max-width: 100%;
    height: auto;
    border: 2px solid #2A3230;
    border-radius: 8px;
  }
`;

const PostCarbonInteraction = () => {
  const subtitles = [
    "A journey towards interactive carbon capture"
  ];
  return (
    <html>
        <PostPageStyle>
          <Header
            title="Carbon Series - Interaction"
            subtitles={subtitles}
          />
          <Image
            image={CaveFlask}
            image_alt="Cave with controller"
          />
          <PostPageBodyStyle>
            <p>
              One of the most challenging issues in dealing with climate change is the incentives for climate action. The environment fits very well in the definition of a class public good in economics. According to the economic theory, a public good has to fulfill two main characteristics: non-rivalrous and non-excludable. Non-rivalrous means the use of the good by someone doesn’t affect the utility by someone else. In other words, two people can enjoy a well preserved forest without affecting each other. For non-excludable, individuals are not able to be excluded from enjoying the good. Some examples of non excludable are light houses and national parks. The maintenance of such goods carries costs that no individual beneficiary has the incentive to cover.
            </p>
            <p>
              On the other hand, private goods do have incentive of being produced since they don’t fulfill the conditions previously discussed. An example that I would like to analyze is video games. As a millennial, I have experienced first hand the rivalrous nature of videos games enclosed in cards/cassettes or CDs. With the spread of the internet as a media of distribution of contents, physical rivalry has winded down. However, the exclusion nature remains very present in our days despite the emergence of free to play games in the past decades.
            </p>
            <p>
              More interesting than looking at videos games as a good, it’s to rather look at the motivation of the players to play them. According to <a href="https://www.goodreads.com/book/show/11236564-glued-to-games">Glued to Games</a> there are three reasons for an individual to play a game: Competence; Sociality; and Autonomy. Each game may fulfill one or more of those needs with varied degree of efficacy.
            </p>
            <p>
              <h3>
                <b>If video games can make us act, can they make us act in a provision of a public good?</b>
              </h3>
              This is the question, I am trying to answer with this project.
            </p>
            <p>
              Back in 2022, I tried to explore if a process of carbon capture could be visible in real time. In such challenge, I developed a prototyped photobioreactor with Spirulina. This bioreactor had two main operations, air renewal mode and air exchange mode. In air renewal, outside air is pumped inside of the bioreactor. In the exchange mode, this air is pump to the microalgae itself to promote exchange of gases. Previously, those two modes were triggered by a schedule. However now, those modes would be triggered by the player itself while playing the game.
            </p>
            <p>
              Given my recent professional experience with serverless technology, in this project, I decided to implement a fully serverless stack. Despite that is good to note that the previous and the current version of the app have different needs (visualization vs interaction), this serverless approach represented a significant reduction of costs. On the video game itself, I wanted bring the vibe of a retro topdown game. For this, I used Unity as a game engine and Aseprite as to sketch the assets (please excuse me my amateur art skills).
            </p>
            <VideoWrapper>
              <video controls>
                <source src={RoverGamePlay} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </VideoWrapper>
            <p>
              On a deserted planet, a rover roams around to harvest energy from renewable sources and supply a bioreactor filled with microalgae. The catch? The level of CO2 reported in the interface is the one provided by the real world prototyped bioreactor. If enough energy is gathered the player can trigger either renewal or exchange modes in the photobioreactor.
            </p>
            <p>
              * This post was written by a human.
            </p>
            </PostPageBodyStyle> 
            <Footer/> 
        </PostPageStyle>
    </html>
)
}

export default PostCarbonInteraction;
